import { getDefaultRFQID } from '@/utils/shared'

const ModelStep = () => {
  return {
    index: '',
    title: '',
    component: '',
    isValid: false,
    showButton: true
  }
}
const ModelRFQNew = (root, store) => {
  return {
    rfqid: getDefaultRFQID(),

    customerCompanyID: null,
    rfqTypeID: 2,
    baxEmployeeID: store.getters.get('currentUser').employeeID,
    priorityID: 1,
    customerContactID: null,
    customerCompanyDetailID: null,
    observation: ''
  }
}
const ModelRFQ1New = (root, store) => {
  return {
    rfqid: null,

    partID: null,
    qty: 1,
    observation: ''
  }
}
const ModelRFQ3New = (root, store) => {
  return {
    rfqid: null,

    chosen: false,
    qty: 1,
    partID: null,
    partSN: '',
    price: '',
    currencyID: null,
    conditionID: null,
    releaseID: null,
    traceabilityCompanyID: null,
    tagInfoCompanyID: null,
    tagDate: null,
    supplyDate: '',
    stockID: null,
    exchangeCoreValue: null,
    exchangeCoreValueCurrencyID: null,
    exchangeConditionID: null,
    coreDueDate: null,
    exchangeCoreReceived: false,
    sendMail: false
  }
}
const ModelRFQPO = (root, store) => {
  return {
    id: null,
    po: null,
    poDate: new Date(),
    requestedDate: null,
    orderRatingScoreID: null,
    paymentTermID: null,
    shipToCompanyID: null,
    shipToCompanyDetailID: null,
    shipToContactID: null,
    customerForwarderID: null
  }
}
export {
  ModelRFQNew,
  ModelRFQ1New,
  ModelRFQ3New,
  ModelRFQPO,
  ModelStep
}
